import React from 'react'
import RadioButton from '../RadioButton'
import styles from './styles.module.scss'

export default function RadioButtonGroup({
  items,
  selectedItemValue,
  onChange,
  radioContainerCSS,
  isDisabled,
  label,
  labelCSS
}) {
  return (
    <div className={`${styles.radioContainer} ${radioContainerCSS}`}>
      {label && <span className={`${styles.label} ${labelCSS}`}>{label}</span>}
      {items.map((item) => (
        <RadioButton
          isDisabled={isDisabled}
          key={item.value}
          item={item}
          isChecked={selectedItemValue ? selectedItemValue == item.value : false}
          onChange={onChange}
        />
      ))}
    </div>
  )
}
